define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

    var vipModelAdminRoles = ['VIP Model Administrator'];
    var vipMaterialAdminRoles = ['VIP Material Administrator'];
    var vipColorAdminRoles = ['VIP Color Administrator'];
    var vipSizeAdminRoles = ['VIP Size Administrator'];
    var vipGenderAdminRoles = ['VIP Gender Administrator'];
    var vipActivityAdminRoles = ['VIP Activity Administrator'];
    var vipCollectionAdminRoles = ['VIP Collection Administrator'];
    var vipPriceListAdminRoles = ['VIP Price List Administrator'];
    var vipRangePlanAdminRoles = ['VIP Range Plan Administrator'];
    var vipClassifierAdminRoles = ['VIP Classifier Administrator'];
    var vipClusterAdminRoles = ['VIP Cluster Administrator'];
    var vipProductAdminRoles = ['VIP Product Administrator'];
    var vipSeasonAdminRoles = ['VIP Season Administrator'];
    var vipBuyingSessionAdminRoles = ['VIP Buying Session Administrator'];
    var vipZoneAdminRoles = ['VIP Zone Administrator'];
    var vipClientAdminRoles = ['VIP Client Administrator'];
    var vipDoorAdminRoles = ['VIP Door Administrator'];
    var vipAssortmentAdminRoles = ['VIP Assortment Administrator'];
    var vipClusterAssortmentAdminRoles = ['VIP Cluster Assortment Administrator'];
    var vipClientAssortmentAdminRoles = ['VIP Client Assortment Administrator'];
    var vipDoorAssortmentAdminRoles = ['VIP Door Assortment Administrator'];
    var vipCrewAdminRoles = ['VIP Crew Administrator'];
    var vipBuyAdminRoles = ['VIP Buy Administrator'];
    var vipBetAdminRoles = ['VIP Bet Administrator'];
    var vipRatingsAdminRoles = ['VIP Ratings Administrator'];
    var vipAllotmentAdminRoles = ['VIP Allotment Administrator'];
    var vipAssortmentReviewRequest = ['VIP Assortment Review Request Administrator'];
    var vipOrderProduct = ['VIP Order Product Administrator'];
    var vipClientOrder = ['VIP Client Order Administrator'];
    var vipDoorOrder = ['VIP Door Order Administrator'];

	var VIPBuyerMembershipAdminRoles = ['VIP Buyer Membership Administrator'];

    csiAccess.addViewRoles({
        "_CS_Data":{
            "VIPModels":{
                "NewVIPModel":access(full(vipModelAdminRoles)),
            },
            "VIPMaterials":{
                "NewVIPMaterial":access(full(vipMaterialAdminRoles)),
            },
            "VIPColors":{
                "NewColorSpecification":access(full(vipColorAdminRoles)),
            },
            "VIPSizes":{
                "NewProductSize":access(full(vipSizeAdminRoles)),
            },
            "VIPSizeRanges":{
                "NewSizeRange":access(full(vipSizeAdminRoles)),
            },
            "VIPGenders":{
                "NewVIPGender":access(full(vipGenderAdminRoles))
            },
            "VIPActivities":{
                "NewVIPActivity":access(full(vipActivityAdminRoles))
            },
            "VIPCollections":{
                "NewVIPCollection":access(full(vipCollectionAdminRoles))
            },
            "VIPPriceLists":{
                "NewVIPPriceList":access(full(vipPriceListAdminRoles))
            },
            "VIPRangePlans":{
                "NewVIPRangePlan":access(full(vipRangePlanAdminRoles))
            },
            "VIPClassifierTypes":{
                "NewVIPClassifierType":access(full(vipClassifierAdminRoles))
            },
            "VIPClassifiers":{
                "NewVIPClassifier":access(full(vipClassifierAdminRoles))
            },
            "VIPClusterStatuses":{
                "VIPClusterStatus":access(full(vipClusterAdminRoles))
            },
            "VIPClusters":{
                "NewVIPCluster":access(full(vipClusterAdminRoles))
            },
            "VIPProducts":{
                "NewVIPProduct":access(full(vipProductAdminRoles))
            },
            "VIPSeasons":{
                "NewVIPSeason":access(full(vipSeasonAdminRoles))
            },
            "VIPBuyingSessionGroups":{
                "NewVIPBuyingSessionGroup":access(full(vipBuyingSessionAdminRoles))
            },
            "VIPZones":{
                "NewVIPZone":access(full(vipZoneAdminRoles))
            },
            "VIPClients":{
                "NewClient":access(full(vipClientAdminRoles))
            },
            "VIPDoors":{
                "NewDoor":access(full(vipDoorAdminRoles))
            },
            "VIPAssortmentTypes":{
                "NewAssortmentType":access(full(vipAssortmentAdminRoles))
            },
            "VIPAssortments":{
                "NewAssortment":access(full(vipAssortmentAdminRoles))
            },
            "VIPClusterAssortments":{
                "NewClusterAssortment":access(full(vipClusterAssortmentAdminRoles))
            },
            "VIPClientAssortments":{
                "NewClientAssortment":access(full(vipClientAssortmentAdminRoles))
            },
            "VIPDoorAssortments":{
                "NewDoorAssortment":access(full(vipDoorAssortmentAdminRoles))
            },
            "VIPRatingType":{
                "NewVIPRatingType":access(full(vipRatingsAdminRoles))
            },
            "VIPAllotments":{
                "NewVIPAllotment":access(full(vipAllotmentAdminRoles))
            },
            "VIPAssortmentReviewRequests":{
                "NewVIPAssortmentReviewRequest":access(full(vipAssortmentReviewRequest))
            },
            "VIPOrderProducts":{
                "NewVIPOrderProduct":access(full(vipOrderProduct))
            },
            "VIPClientOrders":{
                "NewVIPClientOrder":access(full(vipClientOrder))
            },
            "VIPDoorOrders":{
                "NewVIPDoorOrder":access(full(vipDoorOrder))
            }
        },
        "VIPPriceList": {
            "VIPPriceListValues":{
                "NewVIPPriceListValue":access(full(vipPriceListAdminRoles))
            }
        },
        "VIPBuyingSessionGroup": {
            "VIPBuyingSessions":{
                "NewVIPBuyingSession":access(full(vipBuyingSessionAdminRoles))
            },
            "VIPSalesPeriods":{
                "NewVIPSalesPeriod":access(full(vipBuyingSessionAdminRoles))
            }
        },
        "VIPBuyingSession": {
            "VIPBuyingSessionProducts": {
                "NewVIPBuyingSessionProduct":access(full(vipBuyingSessionAdminRoles))
            }
        }
    });
});